import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, PADDING_PAGE, BACKGROUND_RESERVATION_SUCCESS_INFO, COLOR_RESERVATION_SUCCESS_ICON, FONT_SIZE_RESERVATION_SUCCESS_ICON } from '../../../globals';


export const StyledReservationSuccess = styled.div`
  padding: ${PADDING_PAGE}px;
  margin-top: 15px;

  .reservation-success-row {
    margin: 0px;
  }

  .reservation-success-col {
    padding: 0px;
  }

  p {
    margin: 0px;
  }

  .reservation-success-table {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_RESERVATION_SUCCESS_INFO};
  }

  .reservation-success-icon {
    font-size: ${FONT_SIZE_RESERVATION_SUCCESS_ICON}em;
    color: ${COLOR_RESERVATION_SUCCESS_ICON};
    padding: 10px;
  }

  .reservation-success-text {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ReservationSuccess/styles/StyledReservationSuccess.js